$(document).ready(function () {

  // ------------------------------
  // Thumbnail click logic (existing)
  // ------------------------------
  $('.thumbnail').click(function () {
    var target = $(this).data("target");
    $('.slider').removeClass('active');
    $('.slider[data-id=' + target + ']').addClass('active');
  });

  // ------------------------------
  // Price DOM refs
  // ------------------------------

  // Main (big) prices
  var $comparePrice    = $('.prices .compare-price');
  var $regularPrice    = $('.prices .price');

  // Small prices wrapper (right side of "One-time Purchase")
  var $smallPricesWrap = $('.small-prices');

  // Mobile/inline small prices
  var $comparePriceSmall = $('.small-prices .compare-price-small');
  var $regularPriceSmall = $('.small-prices .price-small');

  // Variant radios
  var $variantOptions  = $('.product-variant-selector');

  // Subscribe & Save toggle boxes
  var $subsaveCols      = $('.subsave .col');
  var $subsaveSubscribe = $('.subsave-lhs'); // left: Subscribe & Save
  var $subsaveOnetime   = $('.subsave-rhs'); // right: One-time Purchase

  // Default state: One-time active
  $subsaveCols.removeClass('is-active');
  $subsaveOnetime.addClass('is-active');

  // ------------------------------
  // Core sync function
  // ------------------------------
  function syncVariantAndPrices() {
    var isSub     = $subsaveSubscribe.hasClass('is-active');
    var $selected = $('.product-variant-selector:checked');

    if (!$selected.length) return;

    // Mobile: hide the small price row when S&S is selected
    if (isSub) {
      $smallPricesWrap.addClass('is-hidden-sub');
    } else {
      $smallPricesWrap.removeClass('is-hidden-sub');
    }

    // ----- Variant IDs -----
    var baseId = $selected.data('base-id');
    var subId  = $selected.data('sub-id');

    if (isSub && subId) {
      // Use subscription variant ID for add-to-cart
      $selected.val(subId);
    } else {
      // Use one-time variant ID
      $selected.val(baseId);
    }

    // ----- Prices -----
    // One-time values for THIS bottle size
    var basePrice   = $selected.attr('data-base-price')   || $selected.attr('data-regular-price');
    var baseCompare = $selected.attr('data-base-compare') || $selected.attr('data-compare-price');

    // Subscription discounted price (if exists)
    var subPrice    = $selected.attr('data-sub-price');

    // Logic:
    //  - priceToShow   = sub price OR base price
    //  - compareToShow = ALWAYS the one-time compare price for that size
    var useSub        = isSub && subPrice;
    var priceToShow   = useSub ? subPrice   : basePrice;
    var compareToShow = baseCompare;

    // ------------------------------
    // Update main & small prices
    // ------------------------------

    // Main actual price + small actual price
    if (priceToShow) {
      $regularPrice.text(priceToShow);
      $regularPriceSmall.text(priceToShow);
    }

    // Compare-at / strike-through (main & small)
    if (compareToShow && compareToShow !== priceToShow) {
      // Main compare price (desktop/global)
      $comparePrice.text(compareToShow).show();

      // Small compare price (mobile/right side)
      $comparePriceSmall.text(compareToShow).show();

      $regularPrice.addClass('on-sale');
      $regularPriceSmall.addClass('on-sale-small');
    } else {
      $comparePrice.hide();
      $comparePriceSmall.hide();
      $regularPrice.removeClass('on-sale');
      $regularPriceSmall.removeClass('on-sale-small');
    }

    // ------------------------------
    // Update per-variant desktop inline price
    // (.desktop-price inside the selected label)
    // ------------------------------
    var selectedId = $selected.attr('id'); // e.g. "radio_44621248364597"
    var $selectedLabel = $('label[for="' + selectedId + '"]');

    var $desktopPriceForSelected   = $selectedLabel.find('.desktop-price');
    var $desktopCompareForSelected = $selectedLabel.find('del.hide-price');

    if ($desktopPriceForSelected.length && priceToShow) {
      // Show the active (sub OR one-time) price in that desktop inline span
      $desktopPriceForSelected.text(priceToShow);
    }

    if ($desktopCompareForSelected.length) {
      if (compareToShow && compareToShow !== priceToShow) {
        $desktopCompareForSelected.text(compareToShow).show();
      } else {
        $desktopCompareForSelected.hide();
      }
    }
  }

  // ------------------------------
  // Events
  // ------------------------------

  // When user changes bottle (1 / 3 / 6)
  $variantOptions.on('change', function () {
    // Label active state
    $('.product-variant-selector').parent().find('label').removeClass('active');
    $(this).parent().find('label').addClass('active');

    syncVariantAndPrices();
  });

  // When user toggles Subscribe & Save / One-time
  $subsaveCols.on('click', function () {
    $subsaveCols.removeClass('is-active');
    $(this).addClass('is-active');
    syncVariantAndPrices();
  });

  // Initial state on page load
  $('.product-variants ul li:first-child label').addClass('active');
  syncVariantAndPrices();
});
